import angular, { ILogService } from 'angular'
import { NotificacionService } from '../../../../../_panel/module/uni-base/services/NotifService'
import { Editor } from '../editor'

class EditorAccionesComponentCtrl {
  editor!: Editor<any>

  constructor(private $log: ILogService, private NotifService: NotificacionService) {}

  $onInit(): void {
    this.$log.info('[EditorAccionesComponentCtrl] onInit')
  }

  nuevo() {}

  refresh() {
    this.editor.refresh().then(() => {
      this.NotifService.good('Datos leídos')
    })
  }
}

angular.module('candidato').component('editorAcciones', {
  bindings: {
    editor: '<',
  },
  controller: EditorAccionesComponentCtrl,
  template: require('./editor-acciones.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/editor-acciones/editor-acciones.component.html"
})
